module.exports = __webpack_public_path__ + "img/trampolin.0ec5d9e5.png";